import React from "react";
import { decodeHTML } from "../../util/l10n";
import { ISearchBoxIconProps } from "../../types/searchbox-icon";
import SearchIcon from "../../Assets/svg/Search_2021_icon";

import "./searchbox-icon.scss";

const SearchBoxIcon = (props: ISearchBoxIconProps) => {
    const iconTabNavAttribute = { focusable: true };

    const handleClick = () => {
        // tell HeadR to toggle flyout
        shell?.messageBroker.publishTo("ESMKT.HeadR.ToggleFlyout", "SearchBoxFlyout");
    };

    return (
        <div className={`scope-ssw mkt-headr-icon-wrapper${props.tenant}`} onClick={handleClick}>
            <div
                className="ssw-flyout-icon"
                aria-label={decodeHTML(props.l10nArticleSearch)}
                {...iconTabNavAttribute}
            >
                <SearchIcon className={"mkt-headr-icon"} />
            </div>
        </div>
    );
};

export default SearchBoxIcon;
